import React from "react";
import { Route, Switch } from 'react-router-dom';  // Enables routing between the components
import prepareinvoices from '../../../../EnsembleComponents/TenantComponents/ManageTenants/Invoices/PrepareInvoice';
import invoicesetup from '../../../../EnsembleComponents/TenantComponents/ManageTenants/Invoices/CustomizeInvoice';

  
const InvoiceSubRouting = ({ match }) =>  {
    return (
        <div>
            <Switch>
               <Route path={'/Invoices/prepareinvoices'} component={prepareinvoices}/>   
               <Route path={'/Invoices/invoicesetup'} component={invoicesetup}/>   

            </Switch>
        </div>  
    );
}

export default InvoiceSubRouting;